import axios from './axiosConfig'

export const allCustomise = async () => {
  const response = await axios.get('/customise')
  console.log('get customise data', response.data)
  return response.data
}

export const getAllHideCustomise = async () => {
  const response = await axios.get('/customise/hide')
  console.log(response.data)
  return response.data
}

export const restoreReport = async (id) => {
  const response = await axios.put(`/customise/hide/${id}`)
  return response.data
}

export const getCustomiseById = async (id) => {
  const response = await axios.get(`/customise/${id}`)
  console.log('response at api', response.data)
  return response.data
}

export const createCustomise = async (formData) => {
  try {
    const response = await axios.post('/customise', {
      title: formData.title,
      userEmail: formData.userEmail,
      company: formData.company,
      price: formData.price,
    })
    return response.data
  } catch (error) {
    console.error('Error creating customise:', error)
    throw error
  }
}

export const updateCustomise = async (id, formData) => {
  try {
    const response = await axios.put(`/customise/${id}`, {
      title: formData.title,
      userEmail: formData.userEmail,
      company: formData.company,
      price: formData.price,
    })
    return response.data
  } catch (error) {
    console.error('Error updating customise:', error)
    throw error
  }
}

export const deleteCustomise = async (id, otp) => {
  try {
    const response = await axios.delete(`/customise/${id}?otp=${otp}`, {
      withCredentials: true,
    })

    // console.log('Delete slider response:', response.data)
    return response.data
  } catch (error) {
    console.error('Error deleting slider:', error)
    throw error
  }
}

export const sendMail = async (id) => {
  try {
    const response = await axios.get(`/customise/mail/${id}`, {
      withCredentials: true,
    })

    console.log('mail API response type:', response)
    return response
  } catch (error) {
    console.error('Error fetching sliders:', error)
    throw error
  }
}
